import script from "./MobileMenuMain.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMenuMain.vue?vue&type=script&setup=true&lang=js"

import "./MobileMenuMain.vue?vue&type=style&index=0&id=31029398&lang=scss"

const __exports__ = script;

export default __exports__